import TreeRow from './TreeRow';
import { TreeContext } from "../../../utils/contexts";
import {  List  } from "@mui/material";

export default class Tree extends React.PureComponent {
  render() {
    const { currentSite, treeItems } = this.context;

    return (
      <List>
        <TreeRow
          item={{
            nodeRef: currentSite.nodeRef,
            name: currentSite.label,
            hasChildren: true,
          }}
          level={0}
          treeItems={treeItems}
        />
      </List>
    );
  }
}

Tree.contextType = TreeContext;
